import React from 'react';
import { ManagedDataObject } from '../types';
import { styles } from './PaymentOptions.css';

export type PaymentOptionsProps = {
  paymentOptions?: Array<ManagedDataObject>;
};
export const PaymentOptions = ({ paymentOptions }: PaymentOptionsProps) => {
  return paymentOptions ? (
    <div className={styles.paymentsContainer}>
      <ul className={styles.paymentsList}>
        {paymentOptions.map(option => {
          return (
            <li className={styles.paymentItem} key={option.label}>
              <img src={option.icon} alt={option.ariaLabel} />
            </li>
          );
        })}
      </ul>
    </div>
  ) : null;
};
